import {
  Tooltip as ShadCnTooltip,
  TooltipContent,
  TooltipTrigger
} from '@/ui/Shadcn/tooltip'

const Tooltip = ({
  children,
  ...props
}: {
  children: React.ReactNode
  props?: React.ComponentProps<typeof ShadCnTooltip>
}) => <ShadCnTooltip {...props}>{children}</ShadCnTooltip>

const TooltipTriggerWrapper = ({ children }: { children: React.ReactNode }) => (
  <TooltipTrigger asChild>{children}</TooltipTrigger>
)

const TooltipContentWrapper = ({
  props,
  children
}: {
  props?: React.ComponentProps<typeof TooltipContent>
  children: React.ReactNode
}) => (
  <TooltipContent className="" {...props}>
    {children}
  </TooltipContent>
)

Tooltip.Trigger = TooltipTriggerWrapper
Tooltip.Content = TooltipContentWrapper
TooltipTriggerWrapper.displayName = 'Tooltip.Trigger'
TooltipContentWrapper.displayName = 'Tooltip.Content'

Tooltip.displayName = 'Tooltip'

export default Tooltip
